import { useWindowSize } from '@vueuse/core';

const { width: windowWidth } = useWindowSize();

export function useShowImage() {
  const sizeScreen = {
    mobile: {
      size: '0',
      key: 'mobile'
    },
    tablet: {
      size: '768',
      key: 'tablet'
    },
    desktop: {
      size: '990',
      key: 'desktop'
    },
    widescreen: {
      size: '1440',
      key: 'widescreen'
    }
  };

  const renderImage = (images: any) => {
    if (!images) {
      return;
    }

    let getImage = '';
    Object.entries(sizeScreen).forEach((data) => {
      const { key, size } = data[1];
      if (windowWidth.value >= size && Object.prototype.hasOwnProperty.call(images, key) && images[key]) {
        getImage = images[key];
      }

      if (!getImage && windowWidth.value > size) {
        getImage = images.widescreen;
      }
    });

    if (!getImage) {
      Object.entries(sizeScreen).some((data) => {
        const { key } = data[1];
        if (images[key]) {
          getImage = images[key];
          return true;
        }
      });
    }
    return getImage;
  };
  return {
    renderImage
  };
}
